import { isNonEmptyArray, last } from 'lib/array/arrayUtils'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { getMerchandiseQueryFromFilters } from './MerchandiseSearchPage/merchandiseSearchPageUtils'

export const MIN_SUBCATEGORIES = 3

export function merchandiseCacheKey(merchandiseId: string, prioritisedVariantIds?: Array<string>): string {
  return `${merchandiseId}:${prioritisedVariantIds?.join('_')}`
}

export function getMerchandiseSearchUrl(filters: App.MerchandiseFilters): string {
  const query = getMerchandiseQueryFromFilters(filters)
  return `/search/shop?${query}`
}

export function getMerchandiseCategorySearchUrl(
  category: App.MerchandiseCategory,
): string {
  if (isNonEmptyArray(category.ancestors)) {
    return `/search/shop/${last(category.ancestors).slug}/${category.slug}`
  }
  return `/search/shop/${category.slug}`
}

export function getMerchandiseCategoryUrl(
  category: App.MerchandiseCategory,
): string {
  return `/shop/category/${category.slug}`
}

export function getMerchandiseCategoryPageUrl(
  category: App.MerchandiseCategory,
): string {
  if (category.childCategoryIds.length < MIN_SUBCATEGORIES) {
    // For categories with a small number of subcategories, navigate directly to the
    // slug-based search page to keep category context in the URL without query params
    return getMerchandiseCategorySearchUrl(category)
  }
  return getMerchandiseCategoryUrl(category)
}

export function getMerchandiseBrandSearchUrl(
  brand: App.MerchandiseBrand,
  queryParams?: string,
): string {
  const path = `/search/shop/brands/${brand.slug}/${brand.id}`
  return queryParams ? `${path}?${queryParams}` : path
}

export function getMerchandiseURL(offer: App.MerchandiseOffer): string {
  return `/shop/offer/${offer.slug}/${offer.id}`
}

export function getMerchandiseVariantOptionText(variant: App.MerchandiseOfferVariant): string {
  const items = variant.options?.map(opt => opt.name) ?? []
  if (items.length > 0) {
    const intl = getCurrentIntl()
    const sep = intl.formatMessage(middleDotSeparatorMessage)
    return items.join(` ${sep} `)
  }

  return ''
}

export function getMerchandiseSearchUrlWithCategory(
  parentCategorySlug?: string,
  categorySlug?: string,
  queryParams?: string,
): string {
  if (parentCategorySlug && categorySlug) {
    return `/search/shop/${parentCategorySlug}/${categorySlug}${queryParams ? `?${queryParams}` : ''}`
  } else if (categorySlug) {
    return `/search/shop/${categorySlug}${queryParams ? `?${queryParams}` : ''}`
  } else if (parentCategorySlug) {
    return `/search/shop/${parentCategorySlug}${queryParams ? `?${queryParams}` : ''}`
  } else {
    return `/search/shop${queryParams ? `?${queryParams}` : ''}`
  }
}
